<template>
  <div class="version-module">
    <div class="main-content">
      <span class="module-title">多版本满足不同需求，咨询抢购</span>
      <div class="typeList">
        <div class="versionItem" v-for="(item, i) in versionlist" :key="i">
          <div class="header" :class="'headerColor' + i">
            <div class="titleBox">
              <span class="title">{{ item.title }}</span>
              <div class="subtitle">
                <span class="subtitle1">{{ item.subtitle1 }}</span>
                <span class="subtitle2">{{ item.subtitle2 }}</span>
              </div>
            </div>
          </div>
          <div class="item-body">
            <div class="contentList">
              <div
                class="contentItem"
                v-for="(obj, index) in item.contents"
                :key="index"
              >
                <div class="right-icon-box" :class="'icon-color' + i">
                  <img
                    class="right-icon"
                    src="https://www-static.qbox.me/sem/pili-live-1001/source/img/right-icon.png"
                    alt=""
                  />
                </div>
                <div
                  :class="
                    index == 2
                      ? 'content-text-special special-color' + i
                      : 'content-text'
                  "
                >
                  {{ obj }}
                </div>
              </div>
            </div>
            <div class="price-box">
              <div class="true-price">
                <span class="money-type">¥</span>
                <span class="price-number">{{ item.price1 }}</span>
                <span class="text-unit">/年</span>
              </div>
              <div class="fake-price">
                {{ "市场价：" + item.price2 + "/年" }}
              </div>
            </div>
            <div @click="toClient()" class="item-button" :class="'button-color' + i">购买咨询</div>
          </div>
          <img
            class="specialIcon"
            v-if="i == 2"
            :src="item.specialIcon"
            alt=""
          />
        </div>
      </div>
      <span class="module-tips"
        >*API对接、系统打通、商城打通、私有化部署等需求，相关报价请咨询客服</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "versionModule",
  data() {
    return {
      versionlist: [
        {
          title: "基础版",
          subtitle1: "超低启动成本",
          subtitle2: "适用于初步尝试直播推广",
          contents: [
            "通用的直播功能",
            "支持推流、OBS、网页、APP等主流直播形式，同时开播场次不限",
            "包含20,000GB流量",
          ],
          price1: "3899",
          price2: "5198",
          specialIcon: "",
        },
        {
          title: "进阶版",
          subtitle1: "性价比之王",
          subtitle2: "适用于高速成长型企业",
          contents: [
            "提供通用功能+进阶营销功能",
            "多种互动工具，增强您的用户粘性，降低营销投入，提高转化率",
            "包含40,000GB流量",
          ],
          price1: "7599",
          price2: "10098",
          specialIcon: "",
        },
        {
          title: "旗舰版",
          subtitle1: "功能齐全，价值典范",
          subtitle2: "适用于大中型企业专属直播",
          contents: [
            "包含全覆盖的直播功能",
            "支持定制化品牌形象塑造，打破企业业务边界，满足深度使用需求",
            "包含90,000GB流量",
          ],
          price1: "16999",
          price2: "45298",
          specialIcon: "https://www-static.qbox.me/sem/pili-live-1001/source/img/specialIcon.png",
        },
      ],
    };
  },
  methods:{
    toClient(){
      window.open("https://affim.baidu.com/unique_53498961/chat?siteId=20774082&userId=53498961&siteToken=35708c2ed9714876a5578566862942da&cp=https%3A%2F%2Fwww.qiniu.com%2Fsem%2Fpili-live-1001%2Findex.html&cr=&cw=%E4%B8%83%E7%89%9B%E5%AE%98%E7%BD%91%E4%BC%81%E4%B8%9A%E7%9B%B4%E6%92%AD%E8%AF%A6%E6%83%85%E9%A1%B5");
    }
  }
};
</script>

<style lang="scss" scoped>
.version-module {
  background: #fff;
  height: 777px;
  width: 100%;
  min-width: 1440px;
  display: flex;

  .main-content {
    height: 617px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .module-title {
      height: 48px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 48px;
      letter-spacing: 0px;
      color: #333;
    }
    .typeList {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 459px;
      .versionItem {
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
        box-shadow: 0px 4px 32px 0px #0000000f;
        border-radius: 12px;
        &:hover {
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
          transition: 0.3s ease-in-out;
          transform: translateY(-5px) scale(1.1) !important;
          .header {
            .titleBox {
              .subtitle {
                color: #333;
              }
            }
          }
          .button-color0 {
            position: relative;
            animation: pulse0 2s infinite;
          }
          .button-color1 {
            position: relative;
            animation: pulse1 2s infinite;
          }
          .button-color2 {
            position: relative;
            animation: pulse2 2s infinite;
          }
          @keyframes pulse0 {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
              box-shadow: 0 8px 20px rgba(#8b92ce, 0.5);
            }
            100% {
              transform: scale(1);
            }
          }
          @keyframes pulse1 {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
              box-shadow: 0 8px 20px rgba(#46a7fb, 0.5);
            }
            100% {
              transform: scale(1);
            }
          }
          @keyframes pulse2 {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
              box-shadow: 0 8px 20px rgba(#f9b34c, 0.5);
            }
            100% {
              transform: scale(1);
            }
          }
        }
        .headerColor0 {
          background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/version-1.png");

        }
        .headerColor1 {
          background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/version-2.png");
        }
        .headerColor2 {
          background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/version-3.png");
        }
        .header {
          width: 100%;
          height: 156px;
          display: flex;
          flex-direction: column;
          border-radius: 12px 12px 0 0;
          background-repeat: no-repeat;
              background-size: cover;
              background-position: right;
          .titleBox {
            margin-top: 32px;
            height: 100%;
            display: flex;
            flex-direction: column;
            .title {
              font-family: Alibaba PuHuiTi;
              font-size: 30px;
              font-weight: 700;
              line-height: 36px;
              letter-spacing: 0px;
              margin-bottom: 12px;
              height: 36px;
              color: #333;
            }
            .subtitle {
              font-family: PingFang SC;
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
              letter-spacing: 0px;
              height: 48px;
              display: flex;
              flex-direction: column;
              color: #666666;
              span {
                height: 24px;
              }
            }
          }
        }
        .item-body {
          // width: 100%;
          height: 303px;
          background: #fff;
          display: flex;
          flex-direction: column;
          .contentList {
            display: flex;
            flex-direction: column;
            height: 112px;
            justify-content: space-between;
            padding-bottom: 24px;
            border-bottom: 1px solid #e5e5e5;
            .contentItem {
              display: flex;
              flex-direction: row;
              align-items: center;
              font-family: PingFang SC;
              line-height: 22px;
              letter-spacing: 0px;
              text-align: left;
              .right-icon-box {
                width: 18px;
                height: 18px;
                border-radius: 13px;
                margin-right: 8px;
                display: flex;
                .right-icon {
                  width: 10px;
                  height: 8px;
                  margin: auto;
                }
              }
              .icon-color0 {
                background: linear-gradient(180deg, #8994d0 0%, #769ddb 100%);
              }
              .icon-color1 {
                background: linear-gradient(180deg, #1b6ae6 0%, #388ceb 100%);
              }
              .icon-color2 {
                background: linear-gradient(180deg, #ff7a25 0%, #ffa029 100%);
              }
              .content-text {
                font-size: 14px;
                font-weight: 400;
                color: #666;
              }
              .content-text-special {
                font-size: 18px;
                font-weight: 600;
                -webkit-background-clip: text;
                color: transparent;
              }
              .special-color0 {
                background-image: linear-gradient(
                  180deg,
                  #8b92ce 0%,
                  #719edd 100%
                );
              }
              .special-color1 {
                background-image: linear-gradient(
                  180deg,
                  #1663e4 0%,
                  #3e94ec 100%
                );
              }
              .special-color2 {
                background-image: linear-gradient(
                  180deg,
                  #ff7424 0%,
                  #ffa829 100%
                );
              }
            }
          }
          .price-box {
            height: 26px;
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            letter-spacing: 0px;
            color: #4e5969;
            margin: 28px 0;
            .true-price {
              padding-right: 24px;
              color: #333;
              height: 26px;
              display: flex;
              flex-direction: row;
              align-items: flex-end;
              .money-type {
                height: 14px;
              }
              .price-number {
                font-size: 32px;
                font-weight: 600;
                height: 26px;
                line-height: 26px;
                letter-spacing: 0.06px;
              }
              .text-unit {
                font-size: 12px;
                height: 12px;
                line-height: 12px;
                color: #4e5969;
              }
            }
            .fake-price {
              height: 14px;
              text-decoration: line-through;
            }
          }
          .item-button {
            width: 100%;
            height: 56px;
            border-radius: 30px;
            line-height: 56px;
            text-align: center;
            font-family: PingFang SC;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: 0px;
            color: #fff;
            cursor: pointer;
          }
          .button-color0 {
            background: linear-gradient(
              90.78deg,
              #bbcce4 0%,
              #8b92ce 100%,
              #8b92ce 100%
            );
            &:hover{
              animation: none;
              transform: scale(1.05);
              box-shadow: 0 8px 20px rgba(#8b92ce, 0.5);
              transition: all 0.3s;
            }
          }
          .button-color1 {
            background: linear-gradient(90.78deg, #46a7fb 0%, #337fff 100%),
              linear-gradient(
                0deg,
                rgba(255, 255, 255, 0.2),
                rgba(255, 255, 255, 0.2)
              );
            &:hover {
              animation: none;
              transform: scale(1.05);
              box-shadow: 0 8px 20px rgba(#46a7fb, 0.5);
              transition: all 0.3s;
            }
          }
          .button-color2 {
            background: linear-gradient(90.78deg, #f9b34c 0%, #ff7628 100%);
            &:hover {
              animation: none;
              transform: scale(1.05);
              box-shadow: 0 8px 20px rgba(#f9b34c, 0.5);
              transition: all 0.3s;
            }
          }
        }
        .icon {
          position: absolute;
          width: 123px;
          height: 125px;
          top: 15px;
          right: 15px;
        }
        .specialIcon {
          width: 192px;
          height: 30px;
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -96px;
        }
      }
    }
    .module-tips {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0px;
      color: #969799;
    }
  }
  @media screen and (max-width: 1440px) {
    .main-content {
      width: 1180px;
      .module-title {
        font-size: 36px;
      }
      .typeList {
        width: 1180px;
        .versionItem {
          width: 374px;
          .header {
            .titleBox {
              margin-left: 28px;
            }
          }
          .item-body {
            width: calc(100% - 56px);
            margin-left: 28px;
            margin-right: 28px;
            .content-text {
              width: 292px;
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: 1441px) {
    .main-content {
      width: 1420px;
      .module-title {
        font-size: 40px;
      }
      .typeList {
        width: 1420px;
        .versionItem {
          width: 454px;
          .header {
            .titleBox {
              margin-left: 36px;
            }
          }
          .item-body {
            width: calc(100% - 72px);
            margin-left: 36px;
            margin-right: 36px;
            .content-text {
              width: 350px;
            }
          }
        }
      }
    }
  }
}
</style>